var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassEmptyState",
    {
      attrs: {
        title: _vm.translations.title,
        caption: _vm.translations.caption,
        illustrationPath:
          "/ressources/logged/img/illustrations/empty-automation.svg"
      }
    },
    [
      _vm.showButton
        ? _c("CompassButton", {
            attrs: {
              label: _vm.translations.actions.refresh_page,
              type: "secondary"
            },
            on: { click: _vm.refreshPage }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }